import StoriesCampaign from "../../../views/DriverStories/StoriesCampaign/index.js";
import NewStoriesCampaign from "../../../views/DriverStories/NewStoriesCampaign/index.js";
import StoriesCampaignDetails from "../../../views/DriverStories/StoriesCampaignDetails/index.js";
import NewExternalBrandEntity from "../../../views/DriverStories/NewExternalBrandEntity/index.js";
import ExternalBrandEntityView from "../../../views/DriverStories/ExternalBrandEntityView/index.js";
import MenuNames from "../../../constants/Menu/MenuNames.json";

const DriverStoriesRoutes = [
  {
    menuName: MenuNames.DRIVER_STORIES,
    path: "/stories",
    component: StoriesCampaign,
    exact: true,
  },
  {
    menuName: MenuNames.DRIVER_STORIES,
    path: "/stories/create_campaign",
    component: NewStoriesCampaign,
    exact: true,
  },
  {
    menuName: MenuNames.DRIVER_STORIES,
    path: "/stories/create_external_entity",
    component: NewExternalBrandEntity,
    exact: true,
  },
  {
    menuName: MenuNames.DRIVER_STORIES,
    path: "/stories/view_external_entities",
    component: ExternalBrandEntityView,
    exact: true,
  },
  {
    menuName: MenuNames.DRIVER_STORIES,
    path: "/stories/:id",
    component: StoriesCampaignDetails,
    exact: true,
  },
];

export default DriverStoriesRoutes;
